import {
    GetProductResponse,
    GetProductVariantResponse,
    syliusFetch,
    SyliusImageType,
} from '../../@api/Sylius';
import { transformToProductVariant } from '../../@products/ProductVariant/ProductVariantTransformers';
import { isFetchResultSuccessful } from '../../FetchResult/FetchResult';
import { defaultImage, transformImagePathToImage } from '../../Media/MediaTransformers';
import { EnrichedOrderProductVariant, OrderProductVariant } from './OrderDetail';

export const fetchEnrichedOrderProductVariant = async (
    orderProductVariant: OrderProductVariant,
): Promise<EnrichedOrderProductVariant | undefined> => {
    const { variantId } = orderProductVariant;

    const productVariantResponse = await syliusFetch<GetProductVariantResponse>(`/shop/product-variants/${variantId}`);

    if (!isFetchResultSuccessful(productVariantResponse)) {
        return undefined;
    }

    const productVariantResource = productVariantResponse.data;
    const productVariant = transformToProductVariant(productVariantResource);

    const productDefaultResponse = await syliusFetch<GetProductResponse>(`/shop/products/${productVariant.productCode}`);

    if (!isFetchResultSuccessful(productDefaultResponse)) {
        return undefined;
    }

    const productDefaultResource = productDefaultResponse.data;
    const productDefaultImages = productDefaultResource.images;

    const variantImage = productDefaultImages.find(productImage => productVariantResource.images.includes(productImage['@id']));

    const image = variantImage?.path
        ? transformImagePathToImage(variantImage.path, productVariantResource.name, SyliusImageType.original)
        : defaultImage();

    return {
        ...orderProductVariant,
        productName: productVariant.name || orderProductVariant.productName || '',
        brand: productVariant.brand,
        image,
    };
};
